import { useEffect } from 'react';
import { suppressHelpScoutBeacon } from './helpScoutBeacon';

/**
 * Hide the Help Scout bubble while `active` is true. Re-shows it on release
 * (when `active` turns false or the component unmounts).
 *
 * @param {boolean} active
 * @param {string} [reason]
 */
const useHelpScoutBeaconSuppressed = (active, reason = 'session') => {
  useEffect(() => {
    if (!active || typeof window === 'undefined') {
      return undefined;
    }
    return suppressHelpScoutBeacon(reason);
  }, [active, reason]);
};

export default useHelpScoutBeaconSuppressed;
